(function (IsMobile, $, undefined) {

  var breakpoint = 1024,
      $window = $(window);

  IsMobile.check = function(){
    if ($window.width() < breakpoint) {
      return true;
    }
    return false;
  };

}(window.IsMobile = window.IsMobile || {}, jQuery));
